"use strict";
exports.__esModule = true;
var DebounceLink_1 = require("./DebounceLink");
exports["default"] = DebounceLink_1["default"];
//# sourceMappingURL=index.js.map